var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.downloadXHR)?_c('a',{attrs:{"href":_vm.href,"target":"_blank","download":_vm.filename}},[_vm._t("default")],2):_c('a',{class:{ [_vm.loadingClass]: _vm.loading },attrs:{"href":`${_vm.url}`,"target":"_blank","download":_vm.filename},on:{"click":function($event){return _vm.onClick($event)}}},[_vm._t("default",null,{"loading":_vm.loading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }